import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { debounce } from "../../../../utils/debounce";

// Generalized AsyncDropdown component
export const AsyncDropdown = ({
  apiFunction,
  toOptionLabel,
  placeholder = "Search...",
  isClearable = true,
  debounceInterval = 300,
  handleChange,
  name,
  ...props
}) => {
  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    // Fetch default options on mount
    const fetchDefaultOptions = async () => {
      try {
        const response = await apiFunction("");
        const options = response.data.map((option) => toOptionLabel(option));
        setDefaultOptions(options);
      } catch (error) {
        console.error("Error fetching default options: ", error);
      }
    };

    fetchDefaultOptions();
  }, [apiFunction, toOptionLabel]);

  // Debounce the loadOptions function to limit the number of API calls
  const debouncedLoadOptions = debounce(async (inputValue, callback) => {
    try {
      const response = await apiFunction(inputValue);
      const options = response.data.map((option) => toOptionLabel(option));
      callback(options);
    } catch (error) {
      console.error("Error fetching data: ", error);
      callback([]);
    }
  }, debounceInterval);

  // Function to load options with debouncing applied
  const loadOptions = (inputValue, callback) => {
    debouncedLoadOptions(inputValue, callback);
  };

  // Handle the selection of an option
  const onSelect = (option) => {
    handleChange(option, name);
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#1A1A1A",
      borderColor: state.isFocused ? "#F74902" : "#2D2D2D",
      boxShadow: state.isFocused ? "0 0 0 1px #F74902" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#F74902" : "#6B6B6B",
      },
      minHeight: 38,
      marginBottom: 10,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1A1A1A",
      border: "1px solid #2D2D2D",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#FFFFFF" : "#E5E5E5",
      backgroundColor: state.isSelected ? "#F74902" : state.isFocused ? "#2D2D2D" : "#1A1A1A",
      padding: 10,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6B6B6B",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#FFFFFF",
    }),
    input: (provided) => ({
      ...provided,
      color: "#FFFFFF",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#6B6B6B",
      "&:hover": {
        color: "#F74902",
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: "#6B6B6B",
      "&:hover": {
        color: "#F74902",
      },
    }),
  };

  return (
    // REMOVE MARGIN TOP-3 CLASS
    <div>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions={defaultOptions}
        placeholder={placeholder}
        isClearable={isClearable}
        styles={customStyles}
        onChange={onSelect}
        {...props}
      />
    </div>
  );
};
